import { useEffect, useRef, useState } from "react";

export function useCommand(commandName: string, execute: (params?: any) => boolean) {
  const update = useRef(0);
  const [redraw, setReadraw] = useState(0);

  useEffect(() => {
    var handle = state.commandBus.subscribe((commandName1, params) => {
      var autoRedraw = true;
      if (commandName == (commandName1 as any)) {
        autoRedraw = execute(params);

        if (autoRedraw) {
          update.current = update.current + 1;
          setReadraw(update.current);
        }
      }
    });
    return () => {
      state.commandBus.unsubscribe(handle);
    };
  }, []);

  return [update, ""];
}
